import { inject } from '@angular/core';
import { CanActivateFn, Router } from '@angular/router';
import { Store } from '@ngxs/store';
import { AuthSelectors } from '@shared/store/auth/auth.selectors';
import { map } from 'rxjs/operators';
import { ScreeningQuestionnaireSelectors } from '@shared/store/screening-questionnaire/screening-questionnaire.selectors';

export const hasReferralGuard: CanActivateFn = (route, state) => {
  const store = inject(Store);
  const router = inject(Router);

  return store.select(AuthSelectors.hasConfirmedReferral).pipe(
    map((hasReferral) => {
        return hasReferral ? hasReferral : router.parseUrl('/fill-content/force-fill-referral');
      }
    ));
};